import styled from 'styled-components'

import theme, { breakpoint } from 'style/theme'

export default styled.div`
  text-align: center;

  .why-us-content {
    margin-top: 54px;
    display: flex;

    .why-us-block {
      flex-basis: 30%;
      padding-top: 10px;
      padding-bottom: 20px;

      &:not(:last-child) {
        padding-right: 20px;
        margin-right: 20px;
        border-right: solid 1px #ffdfc7;
      }

      .title-block {
        margin-top: 19px;
        .detail {
          margin-top: 19px;
          color: ${theme.mediumGray};
          white-space: pre-wrap;
        }
      }
    }
  }

  @media (max-width: ${breakpoint.lg}) {
    .why-us-content {
      margin-top: 54px;
      flex-wrap: wrap;
      justify-content: center;

      .why-us-block {
        position: relative;
        flex-basis: 50%;

        &:not(:last-child) {
          padding-right: 0;
          margin-right: 0;
          border-right: none;
        }

        &:nth-child(1) {
          padding-right: 12px;
          &:before {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 97%;
            height: 1px;
            background: #ffdfc7;
            content: '';
          }

          &:after {
            position: absolute;
            top: 0;
            right: 0;
            height: 95%;
            width: 1px;
            background: #ffdfc7;
            content: '';
          }
        }

        &:nth-child(2) {
          padding-left: 12px;
          &:before {
            position: absolute;
            bottom: 0;
            right: 0;
            width: 97%;
            height: 1px;
            background: #ffdfc7;
            content: '';
          }
        }

        &:nth-child(3) {
          padding-right: 12px;
          padding-top: 20px;
          &:after {
            position: absolute;
            bottom: 0;
            right: 0;
            height: 95%;
            width: 1px;
            background: #ffdfc7;
            content: '';
          }
        }

        &:nth-child(4) {
          padding-left: 12px;
          padding-top: 20px;
        }
      }
    }
  }

  @media (max-width: ${breakpoint.md}) {
    .why-us-content {
      margin-top: 30px;
      .why-us-block {
        .title-block {
          margin-top: 10px;
          .detail {
            margin-top: 7px;
            white-space: unset;
          }
        }
      }
    }
  }
`
